export default [
    'pch_provider.pch_provider_account',
	'pch_provider_branch_offices.g_commune',
	'pch_provider_account_movement.pch_type_provider_account_movement',
	'pch_provider_account_movement.pch_provider_payment.pch_detail_provider_payment_sheet',
	'pch_payment_condition',
]